<template>
    <div>
        <Dropdown v-model="companySelected" :options="companies" optionLabel="name" placeholder="Choose Company" />
    </div>
</template>
<script>
export default {
    name: 'LoadCompany',
    props: {
        companies: {
            type: Array,
        },
        userCompanyId: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            companySelected: null,
        };
    },
    watch: {
        userCompanyId: {
            immediate: true,
            handler() {
                this.companySelected = this.userCompanyId;
            },
        },
        companySelected: {
            handler() {
                if (this.companySelected) {
                    /** Set company id to the store when root selects a company */
                    this.$store.commit('auth/setCompanyId', this.companySelected);
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Company Selected', life: 5000 });
                }
            },
        },
    },
    mounted() {
        if (!this.userCompanyId) {
            this.$toast.add({ severity: 'info', summary: 'Root Info', detail: 'Select a company before any operations', life: 3000 });
        }
    },
};
</script>
